import React from "react";
import "./dashboard-third-block.component.scoped.scss";
import { useTranslation } from "react-i18next";
import DashboardTableCard from "../dashboard-table-card/dashboard-table-card.component";
import { Box } from "@material-ui/core";
import DashboardGraphCard from "../dashboard-graph-card/dashboard-graph-card.component";

export default function DashboardThirdBlock(props: any) {
  const { usersRoles, statusChart } = props;
  const { t } = useTranslation();

  return (
    <Box className="cards__content mb-5">
      {statusChart && (
        <Box className="card__content">
          <DashboardGraphCard
            title={t("DASHBOARD.USECASE_STAGES")}
            subTitle={""}
            chart={statusChart.stages}
            type={"horizontalBar"}
          />
        </Box>
      )}

      {usersRoles.data && (
        <Box className="card__content">
          <DashboardTableCard
            title={t(usersRoles.title)}
            subTitle={t(usersRoles.subTitle)}
            columns={usersRoles.columns}
            tableName={usersRoles.tableName}
            data={usersRoles.data}
          />
        </Box>
      )}
    </Box>
  );
}
